import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input() type: string;
  @Input() message: string;
  @Output() alertClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  close() {
    this.alertClick.emit();
  }
}
